// import { createSelector } from 'reselect'

export const getServerName = state => state.name
export const getServerShortName = state => state.shortName

// export const getServerNames = createSelector(
//     [getServerName, getServerShortName],
//     (name, shortName) => ({ name, shortName }),
// )



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/serverNames/selectors.js